import React from 'react';
import classNames from 'classnames';
import CallToAction from "@scentregroup/ui/components/call-to-action";
import Heading from "@scentregroup/ui/components/heading";
import { occurrencesType, callToActionType } from '../../types';
import ExternalLink from '../external-link';
import IconRow from '../icon-row';
import Occurrences from '../occurrences';
import InfoAccordion from '../info-accordion';
import PageSharer from '../page-sharer';
import EventNotification from '../event-notification';
import ArticleHeading from './article-heading';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Article = props => /*#__PURE__*/_jsx("article", {
  className: classNames(style.Article, style.evolved, {
    [style["".concat(props.context, "Context")]]: props.context !== undefined
  }, props.className),
  "data-id": "article_index_Article_article",
  children: /*#__PURE__*/_jsxs("div", {
    className: style.containFlexChildrenForIE11,
    "data-id": "article_index_Article_article_div",
    children: [props.superheading && /*#__PURE__*/_jsx(Heading, {
      type: "extrasmall",
      className: style.superHeading,
      "data-test-id": props.headerDataTestId,
      "data-id": "article_index_Article_Heading",
      children: props.superheading
    }), props.superheading && props.superheading.toUpperCase() === 'EVENT' && /*#__PURE__*/_jsx(EventNotification, {
      className: style.warningNotification,
      "data-id": "article_index_Article_EventNotification"
    }), /*#__PURE__*/_jsx(ArticleHeading, {
      type: props.headingType,
      link: props.link,
      dataTestId: props.dataTestId,
      "data-id": "article_index_Article_div_ArticleHeading",
      children: props.heading
    }), props.subheading && /*#__PURE__*/_jsx(Heading, {
      type: "small",
      className: style.subHeading,
      "data-test-id": props.dataTestId,
      "data-id": "article_index_Article_Heading",
      children: props.subheading
    }), props.location && props.location.length && /*#__PURE__*/_jsx(IconRow, {
      text: props.location,
      icon: "location-drop-pin",
      "data-id": "article_index_Article_IconRow"
    }), props.hoursText && /*#__PURE__*/_jsx(IconRow, {
      text: props.hoursText,
      icon: "hours",
      "data-id": "article_index_Article_IconRow_7"
    }), props.occurrences && /*#__PURE__*/_jsx(Occurrences, {
      occurrences: props.occurrences,
      location: props.location,
      "data-id": "article_index_Article_Occurrences"
    }), props.infoAccordion && /*#__PURE__*/_jsx(InfoAccordion, {
      metaRows: props.infoAccordion,
      purpose: "Event details",
      "data-id": "article_index_Article_InfoAccordion"
    }), props.pastEventsAccordion && /*#__PURE__*/_jsx(InfoAccordion, {
      metaRows: props.pastEventsAccordion,
      purpose: "Past events",
      "data-id": "article_index_Article_InfoAccordion_10"
    }), props.times && /*#__PURE__*/_jsx("div", {
      className: style.times,
      "data-id": "article_index_Article_div",
      children: props.times
    }), (props.callsToAction || props.shareButtonType) && /*#__PURE__*/_jsxs("div", {
      className: style.ctaWrapper,
      "data-id": "article_index_Article_div_12",
      children: [(props.callsToAction || []).map(cta => /*#__PURE__*/_jsx(CallToAction, {
        fullWidth: true,
        element: ExternalLink,
        className: style.cta,
        url: cta.address,
        "data-id": "article_index_Article_CallToAction",
        children: cta.category
      }, cta.address)), props.shareButtonType && /*#__PURE__*/_jsx(PageSharer, {
        fullWidth: true,
        className: style.cta,
        shareButtonType: props.shareButtonType,
        "data-id": "article_index_Article_PageSharer"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: style.body,
      "data-id": "article_index_Article_div_div",
      children: props.children
    })]
  })
});

Article.defaultProps = {
  headingType: 'large'
};
export default Article;